import type { FunctionalComponent as FC } from 'preact';

import { Icon36HelpOutline } from '@vkontakte/icons';

import styles from './styles.module.css';

interface Props {
  hasNotifyBadge?: boolean;
  onClick?: () => void;
}

export const TriggerButton: FC<Props> = ({ hasNotifyBadge, onClick }) => {
  return (
    <span className={styles.button} onClick={onClick}>
      <Icon36HelpOutline width={30} height={30} />
      {hasNotifyBadge ? (
        <span className={styles.notifyBadge}>
          <span className={styles.inner}></span>
        </span>
      ) : null}
    </span>
  );
};
